<template>
    <div class="chart-wrap">
        <div class="chart" ref="chart" v-show="!isEmpty"></div>
        <no-result v-show="isEmpty"></no-result>
    </div>
</template>

<script>
    import NoResult from '../../../components/common/NoResult'
    import '@/common/js/common-plugins';

    const option = {
        tooltip : {
            trigger: 'item',
            formatter: "{b} : {c} "
        },
        toolbox: {
            show: true,
            feature: {
                saveAsImage: {show: true,pixelRatio:2,name:'会员占比' +   new Date().format('yyyyMMddHHmmss')}
            },
            right:20
        },
        xAxis: {
            type: 'category',
            data: ['注  册','已实名', '升  级']
        },
        yAxis: [{
            type: 'value',
            name: '单位：名',
            min: 0,
        }],
        series: [{
            // data: [120, 200, 150, 10,],
            type: 'bar',
            itemStyle: {
                normal: {
                    color: function(params) {
                        //首先定义一个数组
                        var colorList = ['#a2d148','#FF6867','#FFAE2E','#2f4554'];
                        return colorList[params.dataIndex]
                    },
                    //以下为是否显示
                    label: {
                        show: false
                    }
                }
            }
        }],

        // visualMap:[{
        //     type: 'piecewise',
        //     show: false,
        //     color:['#079ADE','#FF6867','#FFAE2E']
        // }]
    };


    export default {
        name: "MemTotalChart",
        components: {
            NoResult
        },
        data() {
            return {
                isEmpty: false,
            };
        },
        props: {
            params:{
                type:Object,
                default:() => {},
            }
        },
        mounted() {
            this.init(); // 初始化图表
            // this.getData(this.params); //获取图表所需数据
        },
        watch: {
            params(newVal, oldVal) {
                if (newVal) {
                    this.getData(newVal); //获取图表所需数据
                } else {
                    this.getData(oldVal); //获取图表所需数据
                }
            },
        },
        methods: {
            init() {
                this.charts = this.$echarts.init(this.$refs.chart);
                this.charts.setOption(option);
            },
            getData(params) {
                const num = params.authTotal + params.noAuthTotal + params.lvTotal + params.regisTotal;
                if (num == 0) {
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                }
                this.charts.setOption(option);
                this.formatData(params); // 图表数据
            },
            formatData(data) {
                this.charts.setOption({
                    series: {
                        data: [data.regisTotal, data.authTotal, data.lvTotal, ]
                    },
                });
            },

        }
    };

</script>

<style scoped>
    .chart-wrap {
        width: 100%;
        height: 350px;
    }

    .chart {
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/echarts/MemTotalChart.vue